<template lang="pug">
  BaseModal.ModalWhitepaperDownload(
    :value="value",
    v-on="$listeners",
    v-bind="$attrs",
    @close="onCancel()"
  )
    template(#title) Download the Report on Farmland Investing
    .modal-content-row
      .modal-content-row__image
        .image-wrap
          BaseImage(
            :src="require('images/general/whitepaper-thumbnail.png')",
            alt="whitepaper",
          )
      .modal-content-row__form
        FormWhitepaperDownload(
          @success="onSuccess"
          @cancel="onCancel"
        )
</template>

<script>
import { mapActions } from 'vuex';
import BaseModal from 'Components/Base/BaseModal';
import FormWhitepaperDownload from 'Components/FormWhitePaperDownload/FormWhitepaperDownload';

export default {
  name: 'ModalWhitepaperDownload',
  components: {
    FormWhitepaperDownload,
    BaseModal,
  },
  props: {
    value: Boolean,
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
    ]),
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('success');
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.modal-header
  .is-h3__title
    @media screen and (max-width: 767px)
      font-size: 18px
      line-height: 28px
      width: 100%
      max-width: 240px
      margin: 0 auto
.modal-content
  &-row
    max-width: 1140px
    margin: 0 auto
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    flex-wrap: wrap
    gap: 30px
    &__image
      max-width: 330px
      max-height: 467px
      height: 100%
      margin: 0 auto
      @media screen and (max-width: 767px)
        margin-bottom: 30px
        padding-right: 15px
      .image-wrap
        position: relative
        width: 100%
        max-width: 330px
        height: 467px
        max-height: 100%
        margin: 0 auto
        img
          width: 100%
          height: 100%
        @media screen and (max-width: 767px)
          margin-bottom: 30px
          max-width: 190px
          max-height: 269px
        &:before
          +mt(.3s)
          content: ''
          position: absolute
          background: $gray-30
          top: 0
          left: 0
          bottom: 0
          right: 0
          @media screen and (max-width: 767px)
            transform: rotate(-8deg)
        &:hover
          +mt(.3s)
          &:before
            +mt(.3s)
            transform: rotate(-8deg)
    &__form
      width: 100%
      max-width: 555px
      flex-shrink: 0
      .cancel-row
        margin-top: 20px
        text-align: center
        @media screen and (max-width: 576px)
          margin-top: 30px
</style>
